"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processWipFiberpaths = exports.processStoredFiberpaths = exports.processStoredFiberpathTypes = void 0;
const camelcase_keys_1 = __importDefault(require("camelcase-keys"));
const lodash_mapvalues_1 = __importDefault(require("lodash.mapvalues"));
function processStoredFiberpathTypes(resp) {
    resp.data.result.storedFiberpathTypes = (0, camelcase_keys_1.default)(resp.data.result.stored_fiberpath_types, {
        deep: true,
        stopPaths: ['available_attributes', 'availableAttributes'],
    });
    resp.data.result.storedFiberpathTypes.forEach((t) => {
        t.availableAttributes = (0, lodash_mapvalues_1.default)(t.availableAttributes, val => (0, camelcase_keys_1.default)(val));
    });
    delete resp.data.result.stored_fiberpath_types;
}
exports.processStoredFiberpathTypes = processStoredFiberpathTypes;
function processStoredFiberpaths(resp) {
    resp.data.result = (0, camelcase_keys_1.default)(resp.data.result, {
        deep: true,
        stopPaths: ['stored_fiberpaths.attributes'],
    });
}
exports.processStoredFiberpaths = processStoredFiberpaths;
function processWipFiberpaths(resp) {
    resp.data.result = resp.data.result.map((fp) => (0, camelcase_keys_1.default)(fp, {
        deep: true,
        stopPaths: ['attributes'],
    }));
}
exports.processWipFiberpaths = processWipFiberpaths;
//# sourceMappingURL=fiberpaths.js.map